import {executeHtmlHooks} from "./htmlHooks";

$(document).ready(function () {
    /**
     *  Open modal on page load
     */
    $('.modal-open-on-load').modal('show');

    /**
     * Scroll to element which triggered the modal after closing
     */
    $('[data-modal-trigger]').on('hidden.bs.modal', function () {

        const el = $(`.${$(this).data('modal-trigger')}`)

        if (el.length) {
            $('html, body').stop().animate({
                scrollTop: el.offset().top
            }, 0);
        }

    });

});

$(document.body).on('show.bs.modal', '.modal', function () {
    window.setTimeout(() => executeHtmlHooks(this), 20);
});
